import Button from './StickyBottomButton';
import Wrapper from './Wrapper';

export default {
  Wrapper,
  Button
};
